import { useEffect, useState } from "react";
import api, { imgUrl } from "@/lib/api";
import SEOHead from "@/components/SEOHead";

export default function Results() {
  const [results, setResults] = useState([]);

  useEffect(() => { api.get("/match-results").then(({ data }) => setResults(data)); }, []);

  return (
    <div data-testid="results-page" className="bg-[var(--pz-ink)] text-white">
      <SEOHead title="Match Results — The Arena" description="Latest scores and standings from the indoor cricket league." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-xs uppercase tracking-[0.35em] text-[var(--pz-red)] font-bold mb-4">Scoreboard</div>
        <h1 className="font-display text-5xl md:text-7xl font-bold uppercase leading-none">Match Results</h1>
        <p className="mt-6 text-zinc-400 max-w-2xl">Latest scores from the Premier League, corporate tournaments and friendlies at the arena.</p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {results.map((r, i) => (
            <article key={r.id} data-testid={`result-card-${i}`} className="bg-white text-[var(--pz-ink)] rounded-md p-6 shadow-sm pz-fade-up" style={{ animationDelay: `${i * 60}ms` }}>
              <div className="text-xs text-zinc-500 text-center mb-4">{new Date(r.match_date).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}</div>
              <div className="flex items-center justify-between gap-2 overflow-hidden">
                <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
                  <div className="h-10 w-10 grid place-items-center bg-[var(--pz-ink)] text-white rounded-full shrink-0 overflow-hidden">
                    {r.team_a_logo ? <img src={imgUrl(r.team_a_logo)} alt={r.team_a_name} className="h-full w-full object-cover" /> : <span className="font-display text-[10px] uppercase">{r.team_a_name.slice(0, 2)}</span>}
                  </div>
                  <div className="text-[9px] uppercase tracking-[0.02em] font-bold leading-tight text-center break-all w-full">{r.team_a_name}</div>
                </div>
                <div className="font-display text-xl xl:text-2xl font-bold leading-none whitespace-nowrap shrink-0">{r.team_a_score}<span className="mx-1 text-zinc-400">-</span>{r.team_b_score}</div>
                <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
                  <div className="h-10 w-10 grid place-items-center bg-[var(--pz-ink)] text-white rounded-full shrink-0 overflow-hidden">
                    {r.team_b_logo ? <img src={imgUrl(r.team_b_logo)} alt={r.team_b_name} className="h-full w-full object-cover" /> : <span className="font-display text-[10px] uppercase">{r.team_b_name.slice(0, 2)}</span>}
                  </div>
                  <div className="text-[9px] uppercase tracking-[0.02em] font-bold leading-tight text-center break-all w-full">{r.team_b_name}</div>
                </div>
              </div>
              <div className="text-center mt-5 text-xs uppercase tracking-[0.2em] text-zinc-500">{r.league}</div>
              <div className="text-center mt-1 text-sm text-zinc-600">{r.venue}</div>
            </article>
          ))}
          {results.length === 0 && <div className="col-span-full text-zinc-500">No results posted yet.</div>}
        </div>
      </div>
    </div>
  );
}
